import React, { useState, useEffect } from "react";
import "./partByModelSearch.css";
import ScrollableComponent from "../ScrollableComponent";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import DownloadIcon from '@mui/icons-material/Download';
import { fetchWithAuth } from "../../utils/fetchWithAuth";
import {
  hasDbEditorUpdateAccessFromStorage,
} from "../../utils/authAccess";
import * as XLSX from "xlsx";




export default function PartByModelSearch({ data = [], setSelectedTab, setPricingData, setPartByModelData, setImageData, modelNumber, documentId }) {
    const [filteredData, setFilteredData] = useState([]);
    const [searchDesc, setSearchDesc] = useState("");
    const [searchDiv, setSearchDiv] = useState("");
    const [searchSrc, setSearchSrc] = useState("");
    const [searchPart, setSearchPart] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);
    const [isEditPartModalOpen, setIsEditPartModalOpen] = useState(false);
    const [isDeleteConfirmModalOpen, setIsDeleteConfirmModalOpen] = useState(false);
    const [isAddPartModalOpen, setIsAddPartModalOpen] = useState(false);
    const [error, setError] = useState("");
    const [modalLoading, setModalLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [addPartLoading, setAddPartLoading] = useState(false);
    const [newPartNumber, setNewPartNumber] = useState("");
    const [newSupplierId, setNewSupplierId] = useState("");
    const [newProductGroup, setNewProductGroup] = useState("");
    const [newPage, setNewPage] = useState("");
    const [newKey, setNewKey] = useState("");
    const [newKeySuffix, setNewKeySuffix] = useState("");
    const [newDescription, setNewDescription] = useState("");
    const [newPageDescription, setNewPageDescription] = useState("");
    const [oldPage, setOldPage] = useState("");
    const [oldKey, setOldKey] = useState("");
    const [originalValues, setOriginalValues] = useState({
        pageId: "",
        keyId: "",
        keySuffixId: "",
        description: "",
        pageDescription: ""
    });
    const [addPartPageId, setAddPartPageId] = useState("");
    const [addPartKeyId, setAddPartKeyId] = useState("");
    const [addPartKeySuffixId, setAddPartKeySuffixId] = useState("");
    const [addPartDivId, setAddPartDivId] = useState("");
    const [addPartSourceId, setAddPartSourceId] = useState("");
    const [addPartNumber, setAddPartNumber] = useState("");
    const [addPartTitle, setAddPartTitle] = useState("");
    const [divisions, setDivisions] = useState([]);
    const [loadingDivisions, setLoadingDivisions] = useState(false);

    const isAdmin = hasDbEditorUpdateAccessFromStorage();
    const username = localStorage.getItem("username") || "DBEditorWeb";
    
    useEffect(() => {
        const modelValue = data && data.length > 0 ? (data[0]?.model || "X") : "X";
        localStorage.setItem("model", JSON.stringify(modelValue));
    }, [data]);

    const hasValidPartDetails = (item) => {
        const partNumber = item.partNumber || item.number;
        const hasPartNumber = partNumber && 
                             typeof partNumber === 'string' && 
                             partNumber.trim() !== '';
        
        const hasPartDetails = (item.partId && String(item.partId).trim() !== '') || 
                              (item.partDescription && String(item.partDescription).trim() !== '') || 
                              (item.partTitle && String(item.partTitle).trim() !== '');
        
        return hasPartNumber && hasPartDetails;
    };

    const refactorDataForPricing = (rows) => {
        const modelFromData = data && data.length > 0 ? (data[0]?.model || null) : null;
        
        return rows.map((row) => {
            let modelValue = row.model || modelFromData;
            if (!modelValue) {
                try {
                    const storedModel = localStorage.getItem("model");
                    modelValue = storedModel ? JSON.parse(storedModel) : "X";
                } catch (e) {
                    modelValue = "X";
                }
            }
            
            const refactoredRow = {
                ...row,
                number: row.partNumber || row.number || '',
                divId: row.divisionId || row.divId || '',
                title: row.partDescription || row.partTitle || row.title || '',
                sourceId: row.sourceId || '',
                model: modelValue
            };
            return refactoredRow;
        });
    };

    useEffect(() => {
        const filtered = data.filter(hasValidPartDetails);
        setFilteredData(filtered)
    }, [data]);

    const handleDescSearch = (event) => {
        const desc = event.target.value;
        setSearchDesc(desc);
        const filtered = data.filter((item) =>
            hasValidPartDetails(item) &&
            (item.partDescription?.toLowerCase().includes(desc.toLowerCase()) ||
             item.partTitle?.toLowerCase().includes(desc.toLowerCase()) ||
             item.title?.toLowerCase().includes(desc.toLowerCase()))
        );
        setFilteredData(filtered);
    };

    const handleDivSearch = (event) => {
        const div = event.target.value;
        setSearchDiv(div);
        const filtered = data.filter((item) => 
            hasValidPartDetails(item) &&
            (item.divisionId?.includes(div) || item.divId?.includes(div))
        );
        setFilteredData(filtered);
    };

    const handleSrcSearch = (event) => {
        const src = event.target.value;
        setSearchSrc(src);
        const filtered = data.filter((item) => 
            hasValidPartDetails(item) &&
            item.sourceId?.includes(src)
        );
        setFilteredData(filtered);
    };

    const handlePartSearch = (event) => {
        const part = event.target.value;
        setSearchPart(part);
        const filtered = data.filter((item) => 
            hasValidPartDetails(item) &&
            ((item.partNumber?.includes(part) || item.number?.includes(part)))
        );
        setFilteredData(filtered);
    };

    const handlePricing = () => {
        const validRows = selectedRows.filter(hasValidPartDetails);
        
        if (validRows.length === 0) {
            console.log("No valid part rows selected for pricing");
        }
        
        const refactoredData = refactorDataForPricing(validRows);
        setSelectedTab("PRICING");
        setPricingData(refactoredData);
    }

    const handleRowClick = (row, index) => {
        const isSelected = selectedRows.some(selectedRow => selectedRow.index === index);

        if (isSelected) {
            setSelectedRows(selectedRows.filter(selectedRow => selectedRow.index !== index));
        } else {
            setSelectedRows([...selectedRows, { ...row, index }]);

        }
    }

    const handleSelectAllRows = () => {
        if (selectedRows.length === filteredData.length) {
            setSelectedRows([]);
        } else {
            const allRows = filteredData.map((row, index) => ({ ...row, index }));
            setSelectedRows(allRows);
        }
    };

    const formatKeyId = (keyId) => {
        return String(keyId || "").padStart(6, "0");
    };

    const handleDownloadPartList = () => {
        const headers = ["PAGE NO", "PLS", "DIV", "PART_NO", "KEY ID", "KEY SUFFIX ID", "DESCRIPTION"];
        const rows = filteredData.map((row) => [
            row.pageId ?? "",
            row.sourceId ?? "",
            (row.divisionId || row.divId) ?? "",
            (row.partNumber || row.number) ?? "",
            formatKeyId(row.keyId),
            row.keySuffixId ?? "",
            (row.partDescription || row.partTitle || row.title) ?? "",
        ]);
        const worksheetData = [headers, ...rows];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Part List");
        const fileName = `Part_List_${modelNumber || "model"}_${new Date().toISOString().slice(0, 10)}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };

    const handleEditPart = () => {
        console.log("Edit part clicked with row:", selectedRows.length);
         if (selectedRows.length === 0) {
            setError("Please select a part to edit.");
         } else if (selectedRows.length === 1) {
           setIsEditPartModalOpen(true);
           setError("");
           const selectedRow = selectedRows[0];
           const pageId = selectedRow.pageId || "";
           const keyId = selectedRow.keyId || "";
           const keySuffixId = selectedRow.keySuffixId || "";
           const description = selectedRow.partDescription || selectedRow.partTitle || selectedRow.title || "";
           const pageDescription = selectedRow.pageDescription || "";
           
           const displayKeyId = String(keyId || "").replace(/^0+/, "") || "";
           const displayPageId = String(pageId || "").replace(/^0+/, "") || "";
           const formattedKeyId = formatKeyId(keyId);
           const formattedPageId = String(pageId || "").padStart(5, "0");
           
           setNewPartNumber((selectedRow.partNumber || selectedRow.number || "").toUpperCase());
           setNewSupplierId(selectedRow.sourceId || "");
           setNewProductGroup(selectedRow.divisionId || selectedRow.divId || "");
           setNewPage(displayPageId);
           setNewKey(displayKeyId);
           setNewKeySuffix(keySuffixId);
           setNewDescription(description);
           setNewPageDescription(pageDescription);
           setOldPage(pageId);
           // Store original keyId without leading zeros for request
           const originalKeyId = String(keyId || "").replace(/^0+/, "") || keyId || "";
           setOldKey(originalKeyId);
           
           setOriginalValues({
               pageId: formattedPageId,
               keyId: formattedKeyId,
               keySuffixId: keySuffixId,
               description: description,
               pageDescription: pageDescription
           });
           } else {
           setError("Please select only one part to edit.");
         }
      };

    const handleSavePart = async () => {
        setError("");
        setModalLoading(true);

        try {
            const currentDocumentId = data && data.length > 0 
                ? (data[0]?.documentId || documentId) 
                : documentId;

            const formattedPageId = String(newPage.trim()).padStart(5, "0");
            const formattedOldPageId = String(oldPage.trim()).padStart(5, "0");
            const keyIdForRequest = String(newKey.trim()).replace(/^0+/, "") || newKey.trim();
            // Use original keyId without leading zeros for oldKeyId parameter
            const oldKeyIdForRequest = String(oldKey.trim()).replace(/^0+/, "") || oldKey.trim();
            
            const payload = {
                pageId: formattedPageId,
                keyId: keyIdForRequest,
                keySuffixId: newKeySuffix.trim() || "",
                divId: newProductGroup.trim(),
                sourceId: newSupplierId.trim() || "",
                number: newPartNumber.trim().toUpperCase(),
                title: newDescription.trim(),
                pageDescription: newPageDescription.trim() || "",
                documentId: currentDocumentId
            };

            await fetchWithAuth({
                method: "PUT",
                endpoint: `/model/updatePartForModelNumber`,
                params: { username: username, oldPageId: formattedOldPageId, oldKeyId: oldKeyIdForRequest },
                headers: { "Content-Type": "application/json" },
                data: payload,
            });

            setIsEditPartModalOpen(false);
            setError("");
            setSelectedRows([]);
            
            await refetchSourceData(modelNumber, currentDocumentId);
        } catch (err) {
            console.error("Error updating part:", err);
            let errorMessage = "Failed to update part. Please try again.";
            
            if (err.response?.data) {
                const errorData = err.response.data;
                
                if (typeof errorData === 'string') {
                    errorMessage = errorData;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                } else if (errorData.error) {
                    errorMessage = typeof errorData.error === 'string' 
                        ? errorData.error 
                        : errorData.error.message || JSON.stringify(errorData.error);
                } else if (errorData.errorMessage) {
                    errorMessage = errorData.errorMessage;
                } else if (errorData.msg) {
                    errorMessage = errorData.msg;
                } else if (typeof errorData === 'object') {
                    const stringValues = Object.values(errorData).filter(v => typeof v === 'string' && v.trim());
                    if (stringValues.length > 0) {
                        errorMessage = stringValues[0];
                    } else {
                        errorMessage = JSON.stringify(errorData);
                    }
                }
            } else if (err.message) {
                errorMessage = err.message;
            }
            
            setError(errorMessage);
        } finally {
            setModalLoading(false);
        }
    };

    const handleCancelEdit = () => {
        setIsEditPartModalOpen(false);
        setError("");
        setNewPartNumber("");
        setNewSupplierId("");
        setNewProductGroup("");
        setNewPage("");
        setNewKey("");
        setNewKeySuffix("");
        setNewDescription("");
        setNewPageDescription("");
        setOldPage("");
        setOldKey("");
        setOriginalValues({
            pageId: "",
            keyId: "",
            keySuffixId: "",
            description: "",
            pageDescription: ""
        });
    };

    const hasChanges = () => {
        const currentPageId = newPage || "";
        const currentKeyId = newKey || "";
        const currentKeySuffixId = newKeySuffix || "";
        const currentDescription = newDescription || "";
        
        return (
            currentPageId.trim() !== (originalValues.pageId || "").trim() ||
            currentKeyId.trim() !== (originalValues.keyId || "").trim() ||
            currentKeySuffixId.trim() !== (originalValues.keySuffixId || "").trim() ||
            currentDescription.trim() !== (originalValues.description || "").trim()
        );
    };

    const refetchSourceData = async (modelNum, docId) => {
        if (!modelNum || !docId) {
            return;
        }

        const refreshedPartData = await fetchWithAuth({
            method: "GET",
            endpoint: `/model/getPartAndPagesByModel`,
            params: { modelNumber: modelNum, documentId: docId },
        });

        let enrichedPartData = refreshedPartData;
        if (Array.isArray(refreshedPartData) && refreshedPartData.length > 0 && data && data.length > 0) {
            const modelInfo = data[0];
            enrichedPartData = [...refreshedPartData];
            if (enrichedPartData[0]) {
                enrichedPartData[0] = {
                    ...enrichedPartData[0],
                    model: modelInfo.model || modelNum || "",
                    brndName: modelInfo.brndName || "",
                    prdName: modelInfo.prdName || "",
                    documentId: docId, 
                };
            }
        } else if (Array.isArray(refreshedPartData) && refreshedPartData.length > 0) {
            enrichedPartData = [...refreshedPartData];
            if (enrichedPartData[0]) {
                enrichedPartData[0] = {
                    ...enrichedPartData[0],
                    documentId: docId, 
                };
            }
        }

        if (setPartByModelData) {
            setPartByModelData(enrichedPartData);
        }
        if (setImageData) {
            setImageData(enrichedPartData);
        }
    };

    const handleDeletePart = () => {
        if (selectedRows.length === 0) {
            setError("Please select at least one part to delete.");
        } else {
            setIsDeleteConfirmModalOpen(true);
            setError("");
        }
    };

    const handleConfirmDelete = async () => {
        setDeleteLoading(true);
        setError("");

        try {
            const currentDocumentId = data && data.length > 0 
                ? (data[0]?.documentId || documentId) 
                : documentId;

            const deletePayload = selectedRows.map((row) => {
                const hsin = row.hsin || "";
                const id = row.id || "";
                const pageId = row.pageId || "";
                // Remove leading zeros for request - only format for display
                const keyId = String(row.keyId || "").replace(/^0+/, "") || row.keyId || "";
                const keySuffixId = row.keySuffixId || "";
                const rowDocumentId = row.documentId || currentDocumentId;

                return {
                    hsin: hsin,
                    id: id,
                    pageId: pageId,
                    keyId: keyId,
                    keySuffixId: keySuffixId,
                    documentId: rowDocumentId
                };
            });

            await fetchWithAuth({
                method: "PUT",
                endpoint: `/model/deletePartForModelNumber`,
                params: { username: username },
                headers: { "Content-Type": "application/json" },
                data: deletePayload,
            });

            setIsDeleteConfirmModalOpen(false);
            setSelectedRows([]);
            setError("");
            
            await refetchSourceData(modelNumber, currentDocumentId);
        } catch (err) {
            console.error("Error deleting parts:", err);
            let errorMessage = "Failed to delete parts. Please try again.";
            
            if (err.response?.data) {
                const errorData = err.response.data;
                
                if (typeof errorData === 'string') {
                    errorMessage = errorData;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                } else if (errorData.error) {
                    errorMessage = typeof errorData.error === 'string' 
                        ? errorData.error 
                        : errorData.error.message || JSON.stringify(errorData.error);
                } else if (errorData.errorMessage) {
                    errorMessage = errorData.errorMessage;
                } else if (errorData.msg) {
                    errorMessage = errorData.msg;
                } else if (typeof errorData === 'object') {
                    const stringValues = Object.values(errorData).filter(v => typeof v === 'string' && v.trim());
                    if (stringValues.length > 0) {
                        errorMessage = stringValues[0];
                    } else {
                        errorMessage = JSON.stringify(errorData);
                    }
                }
            } else if (err.message) {
                errorMessage = err.message;
            }
            
            setError(errorMessage);
        } finally {
            setDeleteLoading(false);
        }
    };

    const handleCancelDelete = () => {
        setIsDeleteConfirmModalOpen(false);
        setError("");
    };

    const fetchDivisions = async () => {
        setLoadingDivisions(true);
        try {
            const divisionsData = await fetchWithAuth({
                method: "GET",
                endpoint: "/divisions/getAllActiveDivision",
            });
            
            let divisionIds = [];
            
            if (Array.isArray(divisionsData)) {
                divisionIds = divisionsData
                    .map((div) => {
                        if (typeof div === 'object' && div !== null) {
                            return div.id || div.divisionId || div.value || null;
                        }
                        return div; 
                    })
                    .filter((id) => id !== null && id !== undefined && id !== '');
            } else if (divisionsData && typeof divisionsData === 'object') {
                const values = Object.values(divisionsData).flat();
                divisionIds = values
                    .map((div) => {
                        if (typeof div === 'object' && div !== null) {
                            return div.id || div.divisionId || div.value || null;
                        }
                        return div;
                    })
                    .filter((id) => id !== null && id !== undefined && id !== '');
            }
            
            setDivisions(divisionIds.sort());
        } catch (err) {
            console.error("Error fetching divisions:", err);
            setError("Failed to load divisions. Please try again.");
        } finally {
            setLoadingDivisions(false);
        }
    };

    const handleAddPart = async () => {
        setIsAddPartModalOpen(true);
        setError("");
        setAddPartPageId("");
        setAddPartKeyId("");
        setAddPartKeySuffixId("");
        setAddPartDivId("");
        setAddPartSourceId("");
        setAddPartNumber("");
        setAddPartTitle("");
        await fetchDivisions();
    };

    const handleSaveAddPart = async () => {
        setError("");
        setAddPartLoading(true);

        try {
            if (!addPartPageId.trim() || !addPartKeyId.trim() || !addPartDivId.trim() || !addPartNumber.trim() || !addPartTitle.trim() || !addPartSourceId.trim()) {
                setError("Please fill in all required fields (Page ID, Key ID, Div ID, Source ID, Number, and Title).");
                setAddPartLoading(false);
                return;
            }

            if (addPartSourceId.trim().length !== 3 || !/^\d{3}$/.test(addPartSourceId.trim())) {
                setError("Source ID must be exactly 3 digits.");
                setAddPartLoading(false);
                return;
            }

            const currentDocumentId = data && data.length > 0 
                ? (data[0]?.documentId || documentId) 
                : documentId;

            const formattedPageId = String(addPartPageId.trim()).padStart(5, "0");
            const keyIdForRequest = String(addPartKeyId.trim()).replace(/^0+/, "") || addPartKeyId.trim();
            
            const payload = {
                pageId: formattedPageId,
                keyId: keyIdForRequest,
                keySuffixId: addPartKeySuffixId.trim() || "",
                divId: addPartDivId.trim(),
                sourceId: addPartSourceId.trim(),
                number: addPartNumber.trim().toUpperCase(),
                title: addPartTitle.trim(),
                documentId: currentDocumentId
            };

            await fetchWithAuth({
                method: "PUT",
                endpoint: `/model/addPartForModelNumber`,
                params: { username: username },
                headers: { "Content-Type": "application/json" },
                data: payload,
            });

            setIsAddPartModalOpen(false);
            setError("");
            
            setAddPartPageId("");
            setAddPartKeyId("");
            setAddPartKeySuffixId("");
            setAddPartDivId("");
            setAddPartSourceId("");
            setAddPartNumber("");
            setAddPartTitle("");

            await refetchSourceData(modelNumber, currentDocumentId);
        } catch (err) {
            console.error("Error adding part:", err);
            let errorMessage = "Failed to add part. Please try again.";
            
            if (err.response?.data) {
                const errorData = err.response.data;
                
                if (typeof errorData === 'string') {
                    errorMessage = errorData;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                } else if (errorData.error) {
                    errorMessage = typeof errorData.error === 'string' 
                        ? errorData.error 
                        : errorData.error.message || JSON.stringify(errorData.error);
                } else if (errorData.errorMessage) {
                    errorMessage = errorData.errorMessage;
                } else if (errorData.msg) {
                    errorMessage = errorData.msg;
                } else if (typeof errorData === 'object') {
                    const stringValues = Object.values(errorData).filter(v => typeof v === 'string' && v.trim());
                    if (stringValues.length > 0) {
                        errorMessage = stringValues[0];
                    } else {
                        errorMessage = JSON.stringify(errorData);
                    }
                }
            } else if (err.message) {
                errorMessage = err.message;
            }
            
            setError(errorMessage);
        } finally {
            setAddPartLoading(false);
        }
    };

    const handleCancelAddPart = () => {
        setIsAddPartModalOpen(false);
        setError("");
        setAddPartPageId("");
        setAddPartKeyId("");
        setAddPartKeySuffixId("");
        setAddPartDivId("");
        setAddPartSourceId("");
        setAddPartNumber("");
        setAddPartTitle("");
    };

    return (
        <div className="mainPageContent">

            {data && data.length !== 0 && (
                <div className="topInfoRow">
                    <div className="infoItem">
                        <h5>Product Type: {data[0].prdName}</h5>
                    </div>
                    <div className="infoItem">
                        <h5>Brand: {data[0].brndName}</h5>
                    </div>
                    <div className="infoItem">
                        <h5>Model: {data[0].model}</h5>
                    </div>
                </div>
            )}

            <ScrollableComponent height="400px">
                <table className="document" style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>
                                <input
                                    type="checkbox"
                                    checked={selectedRows.length === filteredData.length && filteredData.length > 0}
                                    onChange={handleSelectAllRows}
                                />
                            </th>
                            <th>Page Id</th>
                            <th>Key Id</th>
                            <th>Key Suffix Id</th>
                            <th>Div</th>
                            <th>Pls</th>
                            <th>Part Number</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tr>
                        <td />
                        <td />
                        <td />
                        <td />
                        <td>
                            <input type="text" placeholder="Search Div" className="partSearchInput" value={searchDiv}
                                onChange={handleDivSearch} />
                        </td>
                        <td>
                            <input type="text" placeholder="Search Pls" className="partSearchInput" value={searchSrc}
                                onChange={handleSrcSearch} />
                        </td>
                        <td>
                            <input type="text" placeholder="Search Part" className="partSearchInput" value={searchPart} onChange={handlePartSearch} />
                        </td>
                        <td>
                            <input type="text" placeholder="Search Description" className="partSearchInput" value={searchDesc} onChange={handleDescSearch} />
                        </td>

                    </tr>
                    <tbody>
                        {filteredData && filteredData.length !== 0 && filteredData.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedRows.some(selectedRow => selectedRow.index === index)}
                                        onChange={() => handleRowClick(row, index)}
                                    />
                                </td>
                                <td>{row.pageId}</td>
                                <td>{formatKeyId(row.keyId)}</td>
                                <td>{row.keySuffixId}</td>
                                <td>{row.divisionId || row.divId}</td>
                                <td>{row.sourceId}</td>
                                <td > {row.partNumber || row.number} </td>
                                <td>{row.partDescription || row.partTitle || row.title}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ScrollableComponent>
            <div className="buttonPartGroup">
                <table className="buttonTable" style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            {isAdmin && (
                                <td><button className="btn btn-info" onClick={handleAddPart}><AddIcon /> Add Part</button></td>
                            )}
                            {isAdmin && (
                                <td><button className="btn btn-info" disabled={selectedRows.length !== 1} onClick={handleEditPart}><EditIcon />Update Part</button></td>
                            )}
                            {isAdmin && (
                                <td><button className="btn btn-info" disabled={selectedRows.length === 0} onClick={handleDeletePart}><DeleteIcon /> Delete Part</button></td>
                            )}
                            <td><button className="btn btn-info" disabled={selectedRows.length === 0} onClick={handlePricing}><MonetizationOnIcon /> Pricing</button></td>
                            {isAdmin && (
                                <td><button className="btn btn-info" disabled={filteredData.length === 0} onClick={handleDownloadPartList}><DownloadIcon /> Download Part List</button></td>
                            )}
                        </tr>
                    </thead>
                </table>
            </div>

            {error && !isEditPartModalOpen && !isDeleteConfirmModalOpen && !isAddPartModalOpen && (
                <div className="popupOverlay error">
                    <div className="popupContent">
                        <p>{error}</p>
                        <button onClick={() => setError("")}>Close</button>
                    </div>
                </div>
            )}


            {isDeleteConfirmModalOpen && (
                <div className="modalOverlay">
                    <div className="modalContent">
                        <h3>Confirm Delete</h3>
                        {error && <p className="errorText">{error}</p>}
                        <p>
                            Are you sure you want to delete {selectedRows.length} part{selectedRows.length > 1 ? 's' : ''}?
                        </p>
                        {selectedRows.length > 0 && (
                            <div style={{ marginBottom: '16px', maxHeight: '200px', overflowY: 'auto' }}>
                                <strong>Parts to be deleted:</strong>
                                <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
                                    {selectedRows.map((row, index) => (
                                        <li key={index} style={{ marginBottom: '4px' }}>
                                            {row.partNumber || row.number} 
                                            {row.divisionId || row.divId ? ` (Div: ${row.divisionId || row.divId})` : ''}
                                            {row.sourceId ? ` (PLS: ${row.sourceId})` : ''}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <p style={{ color: '#dc3545', fontWeight: 'bold' }}>
                            This action cannot be undone.
                        </p>
                        <div className="modalActions">
                            <button onClick={handleConfirmDelete} disabled={deleteLoading} style={{ backgroundColor: '#dc3545', color: 'white' }}>
                                {deleteLoading ? (
                                    <>
                                        <div className="button-spinner"></div>
                                        Deleting...
                                    </>
                                ) : (
                                    "Delete"
                                )}
                            </button>
                            <button onClick={handleCancelDelete} disabled={deleteLoading}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isAddPartModalOpen && (
                <div className="modalOverlay">
                    <div className="modalContent">
                        <h3>Add Part</h3>
                        {error && <p className="errorText">{error}</p>}
                        
                        <label>
                            Page ID <span style={{ color: 'red' }}>*</span>:
                            <input
                                type="text"
                                value={addPartPageId}
                                onChange={(e) => setAddPartPageId(e.target.value)}
                                disabled={addPartLoading}
                                placeholder="Enter page ID"
                                maxLength={5}
                            />
                        </label>

                        <label>
                            Key ID <span style={{ color: 'red' }}>*</span>:
                            <input
                                type="text"
                                value={addPartKeyId}
                                onChange={(e) => setAddPartKeyId(e.target.value)}
                                disabled={addPartLoading}
                                placeholder="Enter key ID"
                                maxLength={6}
                            />
                        </label>

                        <label>
                            Key Suffix ID (Optional):
                            <input
                                type="text"
                                value={addPartKeySuffixId}
                                onChange={(e) => setAddPartKeySuffixId(e.target.value)}
                                disabled={addPartLoading}
                                placeholder="Enter key suffix ID"
                                maxLength={2}
                            />
                        </label>

                        <label>
                            Div ID <span style={{ color: 'red' }}>*</span>:
                            {loadingDivisions ? (
                                <div style={{ padding: "8px", color: "#666" }}>Loading divisions...</div>
                            ) : (
                                <select
                                    value={addPartDivId}
                                    onChange={(e) => setAddPartDivId(e.target.value)}
                                    disabled={addPartLoading}
                                    style={{
                                        width: "100%",
                                        padding: "8px",
                                        borderRadius: "4px",
                                        border: "1px solid #ccc",
                                        fontSize: "14px",
                                    }}
                                >
                                    <option value="">Select Div ID</option>
                                    {divisions.map((divId) => (
                                        <option key={divId} value={divId}>
                                            {divId}
                                        </option>
                                    ))}
                                </select>
                            )}
                        </label>

                        <label>
                            Source ID <span style={{ color: 'red' }}>*</span>:
                            <input
                                type="text"
                                value={addPartSourceId}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, '').slice(0, 3);
                                    setAddPartSourceId(value);
                                }}
                                disabled={addPartLoading}
                                placeholder="Enter 3-digit source ID"
                                maxLength={3}
                            />
                        </label>

                        <label>
                            Number <span style={{ color: 'red' }}>*</span>:
                            <input
                                type="text"
                                value={addPartNumber}
                                onChange={(e) => setAddPartNumber(e.target.value.toUpperCase())}
                                disabled={addPartLoading}
                                placeholder="Enter part number"
                            />
                        </label>

                        <label>
                            Description <span style={{ color: 'red' }}>*</span>:
                            <input
                                type="text"
                                value={addPartTitle}
                                onChange={(e) => setAddPartTitle(e.target.value)}
                                disabled={addPartLoading}
                                placeholder="Enter Description"
                            />
                        </label>

                        <div className="modalActions">
                            <button onClick={handleSaveAddPart} disabled={addPartLoading}>
                                {addPartLoading ? (
                                    <>
                                        <div className="button-spinner"></div>
                                        Adding...
                                    </>
                                ) : (
                                    "Add"
                                )}
                            </button>
                            <button onClick={handleCancelAddPart} disabled={addPartLoading}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {isEditPartModalOpen && (
                <div className="modalOverlay">
                    <div className="modalContent">
                        <h3>Edit Part</h3>
                        {error && <p className="errorText">{error}</p>}
                        
                        <label>
                            Part Number:
                            <input
                                type="text"
                                value={newPartNumber}
                                onChange={(e) => setNewPartNumber(e.target.value)}
                                disabled={true}
                                placeholder="Enter part number"
                            />
                        </label>

                        <label>
                            Supplier ID (PLS):
                            <input
                                type="text"
                                value={newSupplierId}
                                onChange={(e) => setNewSupplierId(e.target.value)}
                                disabled={true}
                                placeholder="Enter supplier ID"
                            />
                        </label>

                        <label>
                            Product Group (Div):
                            <input
                                type="text"
                                value={newProductGroup}
                                onChange={(e) => setNewProductGroup(e.target.value)}
                                disabled={true}
                                placeholder="Enter product group"
                            />
                        </label>

                        <label>
                            Page ID:
                            <input
                                type="text"
                                value={newPage}
                                onChange={(e) => setNewPage(e.target.value)}
                                disabled={modalLoading}
                                placeholder="Enter page ID"
                                maxLength={5}
                            />
                        </label>

                        <label>
                            Key ID:
                            <input
                                type="text"
                                value={newKey}
                                onChange={(e) => setNewKey(e.target.value)}
                                disabled={modalLoading}
                                placeholder="Enter key ID"
                                maxLength={6}
                            />
                        </label>

                        <label>
                            Key Suffix ID:
                            <input
                                type="text"
                                value={newKeySuffix}
                                onChange={(e) => setNewKeySuffix(e.target.value)}
                                disabled={modalLoading}
                                placeholder="Enter key suffix ID"
                                maxLength={2}
                            />
                        </label>

                        <label>
                            Description:
                            <input
                                type="text"
                                value={newDescription}
                                onChange={(e) => setNewDescription(e.target.value)}
                                disabled={modalLoading}
                                placeholder="Enter description"
                            />
                        </label>

                        <div className="modalActions">
                            <button onClick={handleSavePart} disabled={modalLoading || !hasChanges()}>
                                {modalLoading ? (
                                    <>
                                        <div className="button-spinner"></div>
                                        Saving...
                                    </>
                                ) : (
                                    "Save"
                                )}
                            </button>
                            <button onClick={handleCancelEdit} disabled={modalLoading}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>

    );

}